module.exports = __webpack_public_path__ + "img/kommune-425.62b57173.svg";